import { makeStyles, Typography } from '@material-ui/core'

import React from 'react'

import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles(theme => ({
  circle: {
    borderRadius: '50%',
    padding: 10,
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    '-webkit-touch-callout': 'none' /* iOS Safari */,
    '-webkit-user-select': 'none' /* Safari */,
    '-khtml-user-select': 'none' /* Konqueror HTML */,
    '-moz-user-select': 'none' /* Old versions of Firefox */,
    '-ms-user-select': 'none' /* Internet Explorer/Edge */,
    'user-select': 'none',
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      height: theme.spacing(3),
      width: theme.spacing(3),
      fontSize: 13
    },
    [theme.breakpoints.down('md')]: {
      height: theme.spacing(2),
      width: theme.spacing(2),
      fontSize: 12
    },
    [theme.breakpoints.only('xs')]: {
      height: theme.spacing(2),
      width: theme.spacing(2),
      fontSize: 11
    }
  },
  repainted: {
    backgroundColor: '#ff6200',
    color: '#ffffff'
  },
  ok: {
    backgroundColor: '#01ac00',
    color: '#ffffff'
  },
  repaintedOk: {
    backgroundColor: '#01ac00',
    color: '#ffffff',
    border: 3,
    borderStyle: 'solid',
    borderColor: '#ff6200'
  },
  danger: {
    backgroundColor: '#ff0540',
    color: '#ffffff'
  },
  dangerNR: {
    backgroundColor: '#ff0540',
    color: '#ffffff',
    border: 3,
    borderStyle: 'solid',
    borderColor: '#ff6200'
  }
}))

export default function PartStateIcon(props) {
  const classes = useStyles()
  if (props) {
    if (!props?.state && !props?.paint) {
      return <></>
    }

    if (
      (props?.state?.includes('Перекрас детали') ||
        props?.state?.includes('Деталь перекрашена')) &&
      props.paint <= 500
    ) {
      return (
        <div className={classes.circle + ' ' + classes.repainted}>
          {props?.paint}
        </div>
      )
    } else if (!props?.state?.includes('OK') && props?.paint > 500) {
      return (
        <div className={classes.circle + ' ' + classes.dangerNR}>
          {props?.paint}
        </div>
      )
    } else if (!props.state.includes('OK') && props?.paint <= 500) {
      return (
        <div className={classes.circle + ' ' + classes.danger}>
          {props?.paint}
        </div>
      )
    } else if (props.state.includes('OK') && props.paint > 500) {
      return (
        <div className={classes.circle + ' ' + classes.repaintedOk}>
          <div>{props?.paint}</div>
        </div>
      )
    } else if (props.state.includes('OK') && props?.paint <= 500) {
      return (
        <div className={classes.circle + ' ' + classes.ok}>
          <Typography color={'initial'} align={'center'}>
            {props?.paint}
          </Typography>
        </div>
      )
    } else if (props?.state.includes('OK') && props?.paint === undefined) {
      return (
        <div className={classes.circle + ' ' + classes.ok}>
          <CheckIcon />
        </div>
      )
    } else if (!props.state.includes('OK') && props?.paint === undefined) {
      return (
        <div className={classes.circle + ' ' + classes.danger}>
          <CloseIcon />
        </div>
      )
    }

    return <div className={classes.circle} />
  }
}
